import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card my-3 shadow-sm" }
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = {
  id: "list-tab",
  role: "tablist",
  class: "nav md-pills pills-primary flex-column text-primary"
}
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons small mr-2" }, "description", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Descripción ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons ml-auto" }, "keyboard_arrow_right", -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons small mr-2" }, "list_alt", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Especificaciones ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons ml-auto" }, "keyboard_arrow_right", -1)
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons small mr-2" }, "comment", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Comentarios ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons ml-auto" }, "keyboard_arrow_right", -1)
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons small mr-2" }, "question_answer", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Preguntas y respuestas ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons ml-auto" }, "keyboard_arrow_right", -1)
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "col-9 py-2" }
const _hoisted_27 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-4 font-weight-bold" }, "Descripción del producto", -1)
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-4 font-weight-bold" }, "Especificaciones del producto", -1)
const _hoisted_31 = { class: "table table-bordered" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted w-25" }, "Marca", -1)
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted w-25" }, "Código", -1)
const _hoisted_36 = { key: 2 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted w-25" }, "Indicaciones", -1)
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "text-muted w-25" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-4 font-weight-bold" }, "Comentarios de los compradores", -1)
const _hoisted_41 = { class: "comment-list" }
const _hoisted_42 = { class: "font-weight-bold text-primary" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = { class: "text-muted" }
const _hoisted_45 = { class: "d-flex" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons mr-1 text-lightgray" }, "format_quote", -1)
const _hoisted_47 = {
  key: 0,
  class: "comment-item border-bottom pb-4 mb-4"
}
const _hoisted_48 = { class: "font-weight-bold text-primary" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = { class: "text-muted" }
const _hoisted_51 = { class: "d-flex" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons mr-1 text-lightgray" }, "format_quote", -1)
const _hoisted_53 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "¿Cuéntanos cómo te fue con este producto?", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  class: "btn btn-primary right mt-3",
  value: "COMENTAR"
}, null, -1)
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", null, "Si anteriormente ya compraste este producto y quieres dejar un comentario debes iniciar sesión.", -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-4 font-weight-bold" }, "Preguntas sobre el producto", -1)
const _hoisted_60 = {
  key: 0,
  class: "border-bottom pb-3 mb-3"
}
const _hoisted_61 = { class: "pb-2" }
const _hoisted_62 = { class: "font-weight-bold text-primary mb-0" }
const _hoisted_63 = { class: "text-muted" }
const _hoisted_64 = { class: "mb-0" }
const _hoisted_65 = { class: "pl-5" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex small font-weight-bold mt-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons mr-1 small" }, "question_answer"),
  /*#__PURE__*/_createTextVNode(" Respuesta del vendedor: ")
], -1)
const _hoisted_67 = { class: "mb-0" }
const _hoisted_68 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Aquí puedes dejar tu pregunta:", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "small d-block" }, "El vendedor contestará tu pregunta tan pronto le sea posible.", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  class: "btn btn-primary right mt-3",
  value: "PREGUNTAR"
}, null, -1)
const _hoisted_72 = { key: 1 }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", null, "Para enviar tus preguntas debes iniciar sesión.", -1)
const _hoisted_74 = [
  _hoisted_73
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("h6", {
                class: _normalizeClass(["nav-link py-2 d-flex align-items-center pointer rounded-sm font-weight-semibold", (_ctx.tabProductSelected === 0)? 'text-white bg-primary' : 'text-primary']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tabProductSelected = 0))
              }, _hoisted_10, 2)
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createElementVNode("h6", {
                class: _normalizeClass(["nav-link py-2 d-flex align-items-center pointer rounded-sm font-weight-semibold", (_ctx.tabProductSelected === 1)? 'text-white bg-primary' : 'text-primary']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabProductSelected = 1))
              }, _hoisted_15, 2)
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("h6", {
                class: _normalizeClass(["nav-link py-2 d-flex align-items-center pointer rounded-sm font-weight-semibold", (_ctx.tabProductSelected === 2)? 'text-white bg-primary' : 'text-primary']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tabProductSelected = 2))
              }, _hoisted_20, 2)
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createElementVNode("h6", {
                class: _normalizeClass(["nav-link py-2 d-flex align-items-center pointer rounded-sm font-weight-semibold", (_ctx.tabProductSelected === 3)? 'text-white bg-primary' : 'text-primary']),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tabProductSelected = 3))
              }, _hoisted_25, 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane fade", (_ctx.tabProductSelected === 0)? 'show active' : ''])
            }, [
              _hoisted_28,
              _createElementVNode("div", {
                innerHTML: _ctx.product.attributes.description
              }, null, 8, _hoisted_29)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane fade", (_ctx.tabProductSelected === 1)? 'show active' : ''])
            }, [
              _hoisted_30,
              _createElementVNode("table", _hoisted_31, [
                _createElementVNode("tbody", null, [
                  (_ctx.product.attributes.brand)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("td", null, _toDisplayString(_ctx.product.attributes.brand), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.product.attributes.code)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("td", null, _toDisplayString(_ctx.product.attributes.code), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.product.attributes.indications)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("td", {
                          innerHTML: _ctx.product.attributes.indications
                        }, null, 8, _hoisted_38)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.specifications, (specification, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_39, _toDisplayString(specification.label), 1),
                      _createElementVNode("td", null, _toDisplayString(specification.value), 1)
                    ]))
                  }), 128))
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane fade", (_ctx.tabProductSelected === 2)? 'show active' : ''])
            }, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.comments, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "comment-item border-bottom pb-4 mb-4"
                  }, [
                    _createElementVNode("h6", _hoisted_42, [
                      _createTextVNode(_toDisplayString(item.author) + " ", 1),
                      _hoisted_43,
                      _createElementVNode("small", _hoisted_44, _toDisplayString(_ctx.getFormatDate(item.published.toString())), 1)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createTextVNode(" " + _toDisplayString(item.comment), 1)
                    ])
                  ]))
                }), 128)),
                (_ctx.newComment !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createElementVNode("h6", _hoisted_48, [
                        _createTextVNode(_toDisplayString(_ctx.firstName) + " " + _toDisplayString(_ctx.lastName), 1),
                        _hoisted_49,
                        _createElementVNode("small", _hoisted_50, _toDisplayString(_ctx.time), 1)
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createTextVNode(" " + _toDisplayString(_ctx.newComment), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("form", {
                      onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitComment && _ctx.submitComment(...args))),
                      action: "/",
                      method: "post"
                    }, [
                      _hoisted_54,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        placeholder: "Comentario...",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelComment) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.modelComment]
                      ]),
                      _hoisted_55
                    ], 32)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane fade", (_ctx.tabProductSelected === 3)? 'show active' : ''])
            }, [
              _hoisted_59,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.faqs, (faq) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: faq.id
                }, [
                  (faq.answer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("h6", _hoisted_62, [
                            _createTextVNode(_toDisplayString(faq.author) + " ", 1),
                            _createElementVNode("small", _hoisted_63, "| " + _toDisplayString(_ctx.getFormatDate(faq.published.toString())), 1)
                          ]),
                          _createElementVNode("p", _hoisted_64, _toDisplayString(faq.question), 1)
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("p", _hoisted_67, _toDisplayString(faq.answer), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    _createElementVNode("form", {
                      onSubmit: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitQuestion && _ctx.submitQuestion(...args))),
                      action: "/",
                      method: "post"
                    }, [
                      _hoisted_69,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        placeholder: "Pregunta...",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelQuestion) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.modelQuestion]
                      ]),
                      _hoisted_70,
                      _hoisted_71
                    ], 32)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, _hoisted_74))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}